import { Box, Container, Grid, GridItem } from "@chakra-ui/react"
//import {Users} from "./Users"

const INFO = ['Name: Laila', 'Company: NA', 'Field of Study: TRON!!!', 'Bio: Love to Hack', 'Experience: C++', 'Looking For: Sleep', 'Education: UG']


export const AboutMe = () => (
  <Container centerContent={false} margin='1'>
    <Box textAlign='left'>
      <Box fontSize='45px' paddingTop='5' paddingBottom='2'>
        About Me
      </Box>
    </Box>
    
    
    <Grid templateColumns='repeat(3, 1fr)' gap={1}>
    {INFO.map((info) => {
        return (<GridItem bg='grey' w='100%' p={4} color='white'>
        {info}
      </GridItem>)
      })}
    </Grid>
  </Container>
)